import { handle } from '@modules/professional/page/InfoPage';
import { loader } from '@modules/professional/api/info-page-loader.server';

import InfoPage from '@modules/professional/page/info/InfoPage';
import { inheritMeta } from '~/modules/seo';
export { inheritMeta as meta };
export { loader, handle };
export default InfoPage;
